module.exports = __webpack_public_path__ + "img/marker-master.svg?067717c133cfe42d32c73f754cea0c83";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/maps/marker-master.svg
// module id = 116
// module chunks = 0